<template>
	<div class="abdetail">
		
			<div class="img">
				<img src="http://www.welbell.com/img/N-dncsf_SoaRjKzTDCt9OA20180911164641.jpg"/>
			</div>
			<!--内容-->
			<div class="container">
				<div class="content">
					<img src="https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=331709929,3034057499&fm=27&gp=0.jpg"/>
				</div>
				
				<div class="pages">
					<div class="left">
						<p><i class="el-icon-arrow-left"></i>上一张图片</p>
						<p>加油</p>
					</div>
					<div class="right">
						<p>下一张图片<i class="el-icon-arrow-right"></i></p>
						<p>每一天</p>
					</div>
				</div>
				
				
			</div>
			
	
		
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				title:'方式打开就发货速度来反馈答复了健康的恢复健康'
			}
		},
		methods:{
			
		},
		created(){
			
		}

	}
</script>

<style lang="less" scoped="scoped">
.abdetail{
	.img{
		width:100%;
		height:500px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.content{
		margin-top: 30px;
		margin-bottom: 30px;
		width: 100%;
		height: 600px;
		border: 1px solid #ccc;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.pages{
		width: 100%;
		margin-bottom: 30px;
		.left{
			display: inline-block;
			text-align: left;
			width: 49%;
			padding-left: 50px;
			p{
				margin-top: 5px;
			}
		}
		.right{
			display: inline-block;
			text-align: right;
			width: 50%;
			padding-right: 50px;
			p{
				margin-top: 5px;
			}
		}
	}

}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/AbDetail.vue